// extracted by mini-css-extract-plugin
module.exports = {"mobile":"_2O8_U","root":"FCOC4","onImage":"GD2u1"};